import { useMemo } from 'react'
import {
  dataFetchingError,
  dataFetchingLoading,
  type DataFetchingState,
  dataFetchingSuccess,
} from 'legacy/common/utils/data-fetching/dataFetching.types'
import { type WarehouseLocation } from 'legacy/common/types'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'

type Result = DataFetchingState<WarehouseLocation[]>

export const useWarehouseLocations = (): Result => {
  const warehouseContext = useWarehouseContext()

  const data = useMemo(() => {
    if (!warehouseContext.loaded) {
      return []
    }

    return warehouseContext.warehouse.warehouseLocations
  }, [warehouseContext])

  if (warehouseContext.error) {
    return dataFetchingError<WarehouseLocation[]>(new Error('Failed to fetch warehouse locations.'))
  }
  if (!warehouseContext.loaded) {
    return dataFetchingLoading<WarehouseLocation[]>()
  }

  return dataFetchingSuccess<WarehouseLocation[]>(data)
}
